import {NutrientType} from "@/models/Ingredient/NutrientType";
import {NutritionLabelCountry} from "@/models/NutritionLabels/NutritionLabelCountry";

export const OPTIONAL_CORE_NUTRIENTS = [
  NutrientType.SaturatedFattyAcids,
  NutrientType.TransFattyAcids,
  NutrientType.Fibre,
  NutrientType.Sugars,
  NutrientType.Cholesterol,
  NutrientType.Sodium,
  NutrientType.Potassium,
  NutrientType.Calcium,
  NutrientType.Iron
];

export const OPTIONAL_US_CORE_NUTRIENTS = [
  NutrientType.Fat,
  NutrientType.SaturatedFattyAcids,
  NutrientType.TransFattyAcids,
  NutrientType.Cholesterol,
  NutrientType.Sodium,
  NutrientType.Carbohydrate,
  NutrientType.Fibre,
  NutrientType.Sugars,
  NutrientType.AddedSugar,
  NutrientType.Protein,
  NutrientType.VitaminD,
  NutrientType.Calcium,
  NutrientType.Iron,
  NutrientType.Potassium
];

export const OPTIONAL_US_CORE_NUTRIENTS_FSIS = [
  NutrientType.Fat,
  NutrientType.SaturatedFattyAcids,
  NutrientType.TransFattyAcids,
  NutrientType.Cholesterol,
  NutrientType.Sodium,
  NutrientType.Carbohydrate,
  NutrientType.Fibre,
  NutrientType.Sugars,
  NutrientType.AddedSugar,
  NutrientType.Protein,
  NutrientType.VitaminA,
  NutrientType.VitaminC,
  NutrientType.Calcium,
  NutrientType.Iron
];

export const OPTIONAL_CORE_SUPPLEMENT_NUTRIENTS = [
  NutrientType.Energy,
  NutrientType.Fat,
  NutrientType.SaturatedFattyAcids,
  NutrientType.TransFattyAcids,
  NutrientType.Cholesterol,
  NutrientType.Sodium,
  NutrientType.Carbohydrate,
  NutrientType.Fibre,
  NutrientType.Sugars,
  NutrientType.AddedSugar,
  NutrientType.Protein,
  NutrientType.Potassium,
  NutrientType.Calcium,
  NutrientType.Iron,
  NutrientType.VitaminD
];

export const SUPPLEMENT_NUTRIENTS_US = [
  NutrientType.Biotin,
  NutrientType.Choline,
  NutrientType.Folate,
  NutrientType.Niacin,
  NutrientType.PantothenicAcid,
  NutrientType.Riboflavin,
  NutrientType.Thiamine,
  NutrientType.BetaCarotene,
  NutrientType.Retinol,
  NutrientType.VitaminB6,
  NutrientType.VitaminB12,
  NutrientType.VitaminE,
  NutrientType.VitaminK,
  NutrientType.Chromium,
  NutrientType.Chloride,
  NutrientType.Copper,
  NutrientType.Iodine,
  NutrientType.Magnesium,
  NutrientType.Manganese,
  NutrientType.Molybdenum,
  NutrientType.Phosphorus,
  NutrientType.Selenium,
  NutrientType.Zinc,
  NutrientType.LAlanine,
  NutrientType.LArginine,
  NutrientType.LAsparagine,
  NutrientType.LAsparticAcid,
  NutrientType.LCysteine,
  NutrientType.LGlutamicAcid,
  NutrientType.LGlutamine,
  NutrientType.Glycine,
  NutrientType.LHistidine,
  NutrientType.LIsoleucine,
  NutrientType.LLeucine,
  NutrientType.LLysine,
  NutrientType.LMethionine,
  NutrientType.LPhenylalanine,
  NutrientType.LProline,
  NutrientType.LSerine,
  NutrientType.LThreonine,
  NutrientType.LTyrosine,
  NutrientType.LValine,
  NutrientType.Caffeine,
  // NutrientType.Taurine,
  // NutrientType.Phosphatidylserine,
  // NutrientType.FolicAcid,
  // NutrientType.Boron,
  // NutrientType.Fluoride,
  // NutrientType.Tryptophan,
];

export const SUPPLEMENT_NUTRIENTS_CANADA = [
  NutrientType.Biotin,
  NutrientType.Choline,
  NutrientType.Folate,
  NutrientType.Niacin,
  NutrientType.PantothenicAcid,
  NutrientType.Riboflavin,
  NutrientType.Thiamine,
  NutrientType.BetaCarotene,
  NutrientType.Retinol,
  NutrientType.VitaminB6,
  NutrientType.VitaminB12,
  NutrientType.VitaminE,
  NutrientType.VitaminK,
  NutrientType.Chromium,
  NutrientType.Chloride,
  NutrientType.Copper,
  NutrientType.Iodine,
  NutrientType.Magnesium,
  NutrientType.Manganese,
  NutrientType.Molybdenum,
  NutrientType.Phosphorus,
  NutrientType.Selenium,
  NutrientType.Zinc,
  NutrientType.LAlanine,
  NutrientType.LArginine,
  NutrientType.LAsparagine,
  NutrientType.LAsparticAcid,
  NutrientType.LCysteine,
  NutrientType.LGlutamicAcid,
  NutrientType.LGlutamine,
  NutrientType.Glycine,
  NutrientType.LHistidine,
  NutrientType.LIsoleucine,
  NutrientType.LLeucine,
  NutrientType.LLysine,
  NutrientType.LMethionine,
  NutrientType.LPhenylalanine,
  NutrientType.LProline,
  NutrientType.LSerine,
  NutrientType.LThreonine,
  NutrientType.LTyrosine,
  NutrientType.LValine,
  NutrientType.Caffeine
];

const UK_VOLUNTARY_NUTRIENTS = [
  NutrientType.Iron,
  NutrientType.Calcium
];

// Special UK label type with extended voluntary nutrients
const UK_VOLUNTARY_NUTRIENTS_STANDARD_VERTICAL_LABEL_WITH_RI_FOUR_COLUMN = [
  NutrientType.VitaminA,
  NutrientType.VitaminD,
  NutrientType.VitaminE,
  NutrientType.VitaminK,
  NutrientType.VitaminC,
  NutrientType.Thiamine,
  NutrientType.Riboflavin,
  NutrientType.Niacin,
  NutrientType.VitaminB6,
  NutrientType.FolicAcid,
  NutrientType.VitaminB12,
  NutrientType.PantothenicAcid,
  NutrientType.Biotin,
  NutrientType.Potassium,
  NutrientType.Chloride,
  NutrientType.Calcium,
  NutrientType.Phosphorus,
  NutrientType.Magnesium,
  NutrientType.Iron,
  NutrientType.Zinc,
  NutrientType.Copper,
  NutrientType.Manganese,
  NutrientType.Fluoride,
  NutrientType.Selenium,
  NutrientType.Chromium,
  NutrientType.Molybdenum,
  NutrientType.Iodine,
];

const US_VOLUNTARY_NUTRIENTS = [
  NutrientType.Potassium,
  NutrientType.VitaminA,
  NutrientType.VitaminC,
  NutrientType.VitaminE,
  NutrientType.VitaminK,
  NutrientType.Thiamine,
  NutrientType.Riboflavin,
  NutrientType.Niacin,
  NutrientType.VitaminB6,
  NutrientType.Folate,
  NutrientType.VitaminB12,
  NutrientType.Biotin,
  NutrientType.PantothenicAcid,
  NutrientType.Phosphorus,
  NutrientType.Iodine,
  NutrientType.Magnesium,
  NutrientType.Zinc,
  NutrientType.Selenium,
  NutrientType.Copper,
  NutrientType.Manganese,
  NutrientType.Chromium,
  NutrientType.Molybdenum,
  NutrientType.Chloride,
  NutrientType.Choline,
];

const CANADA_VOLUNTARY_NUTRIENTS = [
  NutrientType.VitaminA,
  NutrientType.VitaminC,
  NutrientType.VitaminD,
  NutrientType.VitaminE,
  NutrientType.VitaminK,
  NutrientType.Thiamine,
  NutrientType.Riboflavin,
  NutrientType.Niacin,
  NutrientType.VitaminB6,
  NutrientType.Folate,
  NutrientType.VitaminB12,
  NutrientType.Biotin,
  NutrientType.PantothenicAcid,
  NutrientType.Choline,
  NutrientType.Phosphorus,
  NutrientType.Iodine,
  NutrientType.Magnesium,
  NutrientType.Zinc,
  NutrientType.Selenium,
  NutrientType.Copper,
  NutrientType.Manganese,
  NutrientType.Chromium,
  NutrientType.Molybdenum,
  NutrientType.Chloride,
];

const FSIS_ROUNDING_RULE_INDEXES = [1, 2];

function isFsisRoundingRule(roundingRuleIndex?: number | null) {
  return FSIS_ROUNDING_RULE_INDEXES.includes(roundingRuleIndex || 0);
}

/**
 * Returns the voluntary nutrients for a given country.
 * @param country
 * @param roundingRuleIndex
 * @param labelType - Optional UK label type name to use label-specific nutrients
 */
export function getVoluntaryNutrients(
  country: NutritionLabelCountry,
  roundingRuleIndex?: number | null,
  labelType?: string,
) {
  const coreNutrients = getCoreNutrients(country, roundingRuleIndex);

  switch (country) {
    case NutritionLabelCountry.Canada:
      return CANADA_VOLUNTARY_NUTRIENTS.filter((n) => !coreNutrients.includes(n));
    case NutritionLabelCountry.US:
      return US_VOLUNTARY_NUTRIENTS.filter((n) => !coreNutrients.includes(n));
    case NutritionLabelCountry.UK:
      // Check for special UK label type
      if (labelType === "StandardVerticalFormatWithRIAdditionalNutrients") {
        return UK_VOLUNTARY_NUTRIENTS_STANDARD_VERTICAL_LABEL_WITH_RI_FOUR_COLUMN.filter((n) => !coreNutrients.includes(n));
      }
      return UK_VOLUNTARY_NUTRIENTS.filter((n) => !coreNutrients.includes(n));
    default:
      return [];
  }
}

export function getSupplementNutrients(country: NutritionLabelCountry) {
  switch (country) {
    case NutritionLabelCountry.Canada:
      return SUPPLEMENT_NUTRIENTS_CANADA;
    case NutritionLabelCountry.US:
      return SUPPLEMENT_NUTRIENTS_US;
    case NutritionLabelCountry.UK:
      return [];
    default:
      return [];
  }
}

export function getCoreNutrients(
  country: NutritionLabelCountry,
  roundingRuleIndex?: number | null,
) {
  switch (country) {
    case NutritionLabelCountry.Canada:
      return OPTIONAL_CORE_NUTRIENTS;
    case NutritionLabelCountry.US:
      return isFsisRoundingRule(roundingRuleIndex)
        ? OPTIONAL_US_CORE_NUTRIENTS_FSIS
        : OPTIONAL_US_CORE_NUTRIENTS;
    case NutritionLabelCountry.UK:
      return [];
    default:
      return [];
  }
}

export function getCoreSupplementNutrients(country: NutritionLabelCountry) {
  switch (country) {
    case NutritionLabelCountry.US:
      return OPTIONAL_CORE_SUPPLEMENT_NUTRIENTS;
    default:
      return [];
  }
}